/******************************************************************************************
 *	Redirector Service
 *******************************************************************************************
 *
 * Has a go() method that accepts a single paramteter representing the path to redirect to.
 * All redirects are made using history.replaceState().
 * The function accepts 3 optional params:
 *   - to: string representing the state name to redirect to. If not specified, the current user role's default state name will be selected
 *   - replace: if true, new state will replace current one in history
 *   - params: object representing state params
 *   - notify: if false, state change events won't be triggered
 *   - reload: if true, force transition even if the state or params have not changed
 */
(function() {
  

  angular.module('rcServices.redirector', []).service(
    'Redirector',
    /* @ngInject */
    function(_, $log, $rootScope, $state, PreLoginRouterState) {
      //Default state name
      var defaultStateName = 'root';
      this.setDefaultStateName = function(route) {
        //If state exists, update default state
        if (route && $state.get(route)) {
          defaultStateName = route;
        }
      };

      //Redirect to newState if present or defaultStateName otherwise.
      this.go = function(newState, replace, params, notify) {
        notify = notify !== false ? true : false; //Default value for notify is `true`

        var validStateName = newState && _.isString(newState);
        var redirectToState;
        var preLoginState = PreLoginRouterState.getName();

        //If the path is invalid, try using preLoginState
        if (!validStateName && preLoginState) {
          redirectToState = preLoginState;
          params = PreLoginRouterState.getParams();
          PreLoginRouterState.clear(); //Only valid once
        } else if (validStateName) {
          //Else, if path is valid
          redirectToState = newState;
        } else {
          //Last resort, default to root
          redirectToState = defaultStateName;
        }

        //Redirect if current state and redirect-to state are different
        if ($state.current.name !== redirectToState) {
          //If the redirectToState is invalid, use default
          if (!$state.get(redirectToState)) {
            redirectToState = defaultStateName;
            params = null; //Forget about any params that would have been set with the invalid redirectToState
            notify = false; //Do not trigger state change event to prevent infinite loop.
          }

          $log.info(
            '%cRedirector ::',
            'color:#009966;font-weight:bold;',
            $state.current.name || '^',
            '>>>',
            redirectToState
          );
          $state.go(redirectToState, params, {
            location: replace === true ? 'replace' : true,
            notify: notify
          });
        }
      };
    }
  );
})();
